export class GenAiProjectConstants {
  static readonly transcript = '{{transcript}}';
  static readonly silenceDialog = '{{silencedialogue}}';
  static readonly firstStepResponse = '{{firstStepResponse}}';
  static readonly holdTranscript = '{{holdtranscript}}';
  static readonly newLine1 = '\n';
  static readonly newLine2 = '\r\n';
  static readonly oldInputText1 = '"input_text1": ';
  static readonly oldInputText2 = '"inputtext2"= ';
}
